import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-xx-small);
	flex-shrink: 0;
`;
